import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	stylesTitle: {
		id: 'company-hub.search-extension.custom-search-config-panel.styles-title',
		defaultMessage: 'Styles',
		description:
			'A visible text label to be used as the title for the custom search config panel styles section',
	},
	fillColorLabel: {
		id: 'company-hub.search-extension.custom-search-config-panel.styles-fill-color-label',
		defaultMessage: 'Fill color',
		description:
			'A visible text label for the fill color setting for the custom search config panel',
	},
	textColorLabel: {
		id: 'company-hub.search-extension.custom-search-config-panel.styles-text-color-label',
		defaultMessage: 'Text color',
		description:
			'A visible text label for the text color setting for the custom search config panel',
	},
	cornerStyleLabel: {
		id: 'company-hub.search-extension.custom-search-config-panel.corner-style-label',
		defaultMessage: 'Corners',
		description:
			'A visible text label for the corner style setting for the custom search config panel',
	},
	placeholderTextLabel: {
		id: 'company-hub.search-extension.custom-search-config-panel.placeholder-text-label',
		defaultMessage: 'Placeholder text',
		description:
			'A visible text label for the placeholder text setting for the custom search config panel',
	},
	placeholderTooltipLabel: {
		id: 'company-hub.search-extension.custom-search-config-panel.placeholder-tooltip-label',
		defaultMessage: 'Customize the prompt your readers will see',
		description:
			'A visible tooltip label for the placeholder text setting for the custom search config panel',
	},
	roundCornerStyleLabel: {
		id: 'company-hub.search-extension.custom-search-config-panel.round-corner-style-label',
		defaultMessage: 'Round',
		description:
			'A visible text label for the round corner style setting for the custom search config panel',
	},
	sharpCornerStyleLabel: {
		id: 'company-hub.search-extension.custom-search-config-panel.sharp-corner-style-label',
		defaultMessage: 'Square',
		description:
			'A visible text label for the sharp corner style setting for the custom search config panel',
	},
	defaultPlaceholderText: {
		id: 'company-hub.search-extension.custom-search-config-panel.default-placeholder-text',
		defaultMessage: 'Search for verified announcements, resources, and policies',
		description: 'A default placeholder text for the search input configuration',
	},
});
